import { RemoveCircleOutlineOutlined } from '@mui/icons-material';
import BadgeIcon from '@mui/icons-material/Badge';
import CompareIcon from '@mui/icons-material/Compare';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import InfoIcon from '@mui/icons-material/Info';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import {
  Backdrop,
  Button,
  CircularProgress,
  IconButton,
  SvgIcon,
  Switch,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  styled,
  tooltipClasses,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Box, Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Ai_Video_Url } from 'src/config-global';
import { analytics, currencyFormat } from 'src/utils';
import StarIcon from '@mui/icons-material/Star';
import BarsComponent from './bar/BarsComponent';
import { BarSlider } from './BarSlider';
import { SelectComponent } from './hook-form';
import ListComponent from './list/ListComponent';
// import reSkillBarVideo from '../assets/videos/video-3a.mp4'
// import upSkillBarVideo from '../assets/videos/video-3b.mp4'
import { ReactComponent as flagIcon } from '../assets/images/flag.svg';
import svgMobile from '../assets/images/speech-bubble-mobilev2.svg';
import svg from '../assets/images/speech-bubblev2.svg';
import AiVideo from './player/AiVideo';

const sortingOptions = [
  {
    label: 'Highest Salary First',
    value: 'highestSalary',
  },
  {
    label: 'Most Courses Available First',
    value: 'mostCourses',
  },
  {
    label: 'Shortest Transfer Window First',
    value: 'shortestTransfer',
  },
];

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'black',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'black',
    fontSize: '0.9rem !important',
    maxWidth: '260px !important',
    padding: '15px !important',
  },
}));

const barChartToolTip = `This chart shows you all of the careers that require a skill set that is similar to your own. \n
                        Select the sectors or subsectors to see the exciting careers options you have the potential to upskill or reskill into. \n  
                        Press > to see more information including the courses that support each career.`;
const listViewToolTip = `This list shows you all of the careers that require a skill set that is similar to your own. \n
                        Use the sorting menu to explore the exciting careers options you have the potential to upskill or reskill into. \n 
                        Press > to see more information including the courses that support each career.`;

const GraphsData = ({
  regionData,
  isReskill,
  handleToggle,
  isRegion,
  scrollRef,
  status,
  reskillBar,
  showCompareCareersPopup,
  compareCareersState,
  careersUpskillTime,
  addToCompare,
  showCareerDetailsPopup,
  isLoading,
  careerHistoryId,
  IP,
  careerGoalId,
  getSkillReport,
  collegeId,
  currentRoleData,
}) => {
  const [Careers, setCareers] = useState([]);
  const [sortCareerBy, setSortCareerBy] = useState(sortingOptions[0]);
  const [filteredSectors, setFilteredSectors] = useState(careersUpskillTime?.sectorOrSubsector);
  const [toggleValue, setToggleValue] = useState('bar');
  const [salaryRange, setSalaryRange] = React.useState([0, 0]);
  const [minMaxSalary, setMinMaxSalary] = useState([0, 0]);
  const [minMaxTransfer, setMinMaxTransfer] = useState([0, 0]);
  const [transferWindowRange, setTransferWindowRange] = React.useState([0, 0]);
  const [careerCount, setCareerCount] = useState(0);
  const [showLabel, setShowLabel] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [widthClass, setWidthClass] = useState('bar-wrapper-mob');
  const [preSelectedCareers, setPreSelectedCareers] = useState({
    CurrentRole: false,
    CareerGoal: false,
  });
  // Get current role display data
  const getCurrentRoleDisplayData = () => {
    // First try to find in state
    let currentRoleFromState = null;
    careersUpskillTime?.sectorOrSubsector?.forEach((sector) => {
      const currentRole = sector?.careers?.find((career) => career?.careerType === 'CURRENT_ROLE');
      if (currentRole) {
        currentRoleFromState = {
          name: currentRole.name,
          color: sector.color,
          sectorName: sector.name,
          source: 'state',
        };
      }
    });

    // Fallback to prop data
    if (!currentRoleFromState && currentRoleData && currentRoleData.length > 0) {
      return {
        name: currentRoleData[0].label,
        color: regionData?.buttonColor || '#1976d2', // Use dynamic color or default
        sectorName: 'Current Role',
        source: 'prop',
      };
    }

    return currentRoleFromState;
  };

  const currentRoleDisplay = getCurrentRoleDisplayData();
  const handleChangeView = (event, newAlignment) => {
    if (newAlignment !== null) {
      setToggleValue(newAlignment);
    }
    if (newAlignment === 'bar') {
      analytics({
        collegeId,
        event: 'SCATTER_GRAPH_CLICK',
        from: 'Career Courses',
        // from: openCompareCareersPopup ? 'comparision' : 'career-courses',
      });
    } else if (newAlignment === 'list') {
      analytics({
        collegeId,
        event: 'LIST_GRAPH_CLICK',
        from: 'Career Courses',
        // from: openCompareCareersPopup ? 'comparision' : 'career-courses',
      });
    }
  };
  const videoClassOpen = {
    position: 'relative',
    width: '100%',
    zIndex: 999,
    bottom: 0,
    left: '50%',
    mb: 4,
    transform: 'translateX(-50%)',
  };
  const videoClassClose = {
    mb: 4,
  };
  useEffect(() => {
    const newCareerState = [];
    let maxSalary = 0;
    let minSalary = Infinity;
    let maxTransfer = 0;
    let minTransfer = Infinity;

    careersUpskillTime?.sectorOrSubsector?.forEach((sector) => {
      sector.careers.forEach((career) => {
        const salary =
          typeof career.salary === 'number' && !Number.isNaN(career.salary) ? career.salary : 0;
        const transferMin =
          typeof career.transferWindowMin === 'number' && !Number.isNaN(career.transferWindowMin)
            ? career.transferWindowMin
            : 0;
        const transferMax =
          typeof career.transferWindowMax === 'number' && !Number.isNaN(career.transferWindowMax)
            ? career.transferWindowMax
            : 0;

        newCareerState.push({
          ...career,
          color: sector?.color,
          sectorName: sector?.name,
        });

        if (salary > maxSalary) maxSalary = salary;
        if (salary < minSalary && salary !== 0) minSalary = salary;

        if (transferMin < minTransfer && transferMin !== 0) minTransfer = transferMin;
        if (transferMax > maxTransfer) maxTransfer = transferMax;
      });
    });

    // Handle case where all values were 0 or invalid
    if (!Number.isFinite(minSalary)) minSalary = 0;
    if (!Number.isFinite(minTransfer)) minTransfer = 0;

    setSalaryRange([minSalary, maxSalary]);
    setMinMaxSalary([minSalary, maxSalary]);
    setMinMaxTransfer([minTransfer, maxTransfer]);
    setTransferWindowRange([minTransfer, maxTransfer]);
    setCareers(newCareerState);
  }, [careersUpskillTime, collegeId]);
  useEffect(() => {
    const newCareerState = [];
    filteredSectors?.map((sector) =>
      sector.careers.map((career) => {
        newCareerState.push({
          ...career,
          color: sector?.color,
          sectorName: sector?.name,
        });
        return newCareerState;
      })
    );

    setCareers(newCareerState);
  }, [filteredSectors]);

  // useEffect(() => {
  //     if (openPopup) {
  //         setTimeout(() => {
  //             openLabel()
  //         }, 400);
  //     }
  // }, [openPopup])

  // ? Prev functionality for Filtering out Careers * //

  useEffect(() => {
    const filtereddata = careersUpskillTime?.sectorOrSubsector?.map((sector) => ({
      ...sector,
      careers: sector?.careers?.filter((career) => {
        const isSalaryValid =
          career?.salary === 'N/A' ||
          career?.salary === undefined ||
          (career?.salary >= salaryRange[0] && career?.salary <= salaryRange[1]);

        const isTransferWindowValid =
          career?.transferWindowMin >= transferWindowRange[0] &&
          career?.transferWindowMax <= transferWindowRange[1];

        return isSalaryValid && isTransferWindowValid;
      }),
    }));
    setFilteredSectors(filtereddata);
  }, [salaryRange, careersUpskillTime?.sectorOrSubsector, transferWindowRange]);

  // useEffect(() => {
  //   setFilteredSectors(careersUpskillTime?.sectorOrSubsector);
  // }, [careersUpskillTime?.sectorOrSubsector]);

  // useEffect(() => {
  //     if (status?.isSuccess) {
  //         setTimeout(() => {
  //             scrollToTop()
  //             // openLabel()
  //         }, 500);
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [status.isSuccess])

  const closeLabel = () => {
    setShowLabel(false);
    document.body.style.overflow = 'unset';
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    setWidthClass('bar-wrapper-mob');
  };
  const openLabel = () => {
    setShowLabel(true);
    // if (typeof window !== 'undefined' && window.document) {
    //     document.body.style.overflow = 'unset';
    //     // window.scrollTo({
    //     //   top: 60,
    //     //   behavior: "smooth"
    //     // });
    // }
  };
  // const scrollRef = useRef(null)
  const scrollToTop = () => {
    const element = scrollRef?.current;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end' });
      setOpenPopup(true);
    }
  };
  const handleSalaryChange = (event, newValue) => {
    setSalaryRange(newValue);
  };
  const handleTransferChange = (event, newValue) => {
    setTransferWindowRange(newValue);
  };

  const handleSortingOptionChange = (event) => {
    setSortCareerBy(event);
  };

  useEffect(() => {
    let foundCurrentRole = false;
    let foundCareerGoal = false;

    careersUpskillTime?.sectorOrSubsector?.map((sector) =>
      sector?.careers?.map((career) => {
        if (career?.careerType === 'CAREER_GOAL') {
          setPreSelectedCareers((previousSelected) => ({ ...previousSelected, CareerGoal: true }));
          foundCareerGoal = true;
        } else if (career?.careerType === 'CURRENT_ROLE') {
          setPreSelectedCareers((previousSelected) => ({ ...previousSelected, CurrentRole: true }));
          foundCurrentRole = true;
        }
        return [];
      })
    );

    // * Fallback: If no current role found in state but we have currentRoleData prop
    if (!foundCurrentRole && currentRoleData) {
      setPreSelectedCareers((prev) => ({ ...prev, CurrentRole: true }));
    }
  }, [
    compareCareersState,
    careerHistoryId,
    careersUpskillTime?.sectorOrSubsector,
    currentRoleData,
    regionData,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let count = 0;
    const currentRoleCareersFromState =
      careersUpskillTime?.sectorOrSubsector?.reduce((acc, sector) => {
        const currentRoles = sector?.careers?.filter(
          (career) => career?.careerType === 'CURRENT_ROLE'
        );
        return acc + (currentRoles?.length || 0);
      }, 0) || 0;

    let currentRoleCareers = 0;
    if (currentRoleCareersFromState > 0) {
      currentRoleCareers = currentRoleCareersFromState;
    } else if (currentRoleData?.length > 0) {
      currentRoleCareers = 1;
    }

    const careerGoalCareers =
      careersUpskillTime?.sectorOrSubsector?.reduce((acc, sector) => {
        const goalCareers = sector?.careers?.filter(
          (career) => career?.careerType === 'CAREER_GOAL'
        );
        return acc + (goalCareers?.length || 0);
      }, 0) || 0;

    const totalSelectedCareers = currentRoleCareers + careerGoalCareers;
    if (totalSelectedCareers === 0 && careerHistoryId?.length > 0) {
      count = 1 + (careerGoalId ? 1 : 0);
    } else {
      count = totalSelectedCareers;
    }

    if (compareCareersState?.length > 0) {
      const countD = count + compareCareersState.length;
      setCareerCount(countD);
    } else {
      setCareerCount(count);
    }
  }, [
    compareCareersState,
    careersUpskillTime,
    currentRoleData,
    careerGoalId,
    careerHistoryId?.length,
  ]);

  // useEffect(()=>{
  //     if(Careers){
  //         const filteredCareers = Careers?.filter((item)=> item?.careerType !== "CAREER_GOAL" && item?.careerType !== "CURRENT_ROLE")
  //         const filteredCareersId = filteredCareers.map((item)=> item.id);
  //         const date = new Date();
  //         // if(collegeId){
  //         //     analytics({
  //         //         collegeId,
  //         //         event: 'CAREER_RECOMMEND_IDS',
  //         //         from: 'career-courses',
  //         //         data: {
  //         //             "careerRecommedIds": filteredCareersId
  //         //         },
  //         //         date: date.toISOString,
  //         //         IP
  //         //     })

  //         // }
  //     }
  // }, [Careers]) // eslint-disable-line react-hooks/exhaustive-deps

  const thm = useTheme();
  const isMobile = useMediaQuery(thm.breakpoints.down(1025));
  const isXs = useMediaQuery(thm.breakpoints.down('sm'));
  const buttonColor = regionData ? regionData?.button?.bgColor || regionData?.buttonColor : '';
  const buttonFontColor = regionData
    ? regionData?.button?.color || regionData?.buttonFontColor
    : '';
  const primaryColor = regionData ? regionData?.primaryColor : thm.palette.primary.main;

  return (
    <>
      <Box
        display="flex"
        //  columnGap={2}
        // flexDirection="column"
        justifyContent="space-between"
        className=" bar-chart-wrapper"
        mt={0.2}
        mb={3}
        // sx={{ border: (theme) => `2px solid ${theme.palette.primary.main}` }}
      >
        <>
          {isLoading ? (
            <Box
              // className="bar-chart"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginX: 'auto',
                bgcolor: isRegion ? 'white' : 'unset',
                width: '100%',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Box
                className="bar-chart"
                sx={{
                  pt: 2,
                  overflow: 'hidden',
                  bgcolor: isRegion ? 'white' : 'unset',
                  borderRadius: {
                    xs: '0px',
                    '@media (min-width: 1024px)': {
                      borderRadius: '0 0 0 12px',
                    },
                  }, // Added for border radius responsiveness
                }}
              >
                <Box className="bar-head">
                  <Box sx={{ color: '#000c3b', mr: 2, width: { md: '100%', sm: '100%' } }}>
                    <Typography
                      sx={{ fontSize: '16px !important', fontWeight: 700 }}
                      textAlign="start"
                      color="primary.dark"
                    >
                      Explore Your Career Options. Using your work history, we’ve identified roles
                      that reflect your skills and open up new reskilling and upskilling
                      opportunities for the future.
                      <br />
                      Press {'>'} to see more information about careers in each sector.
                    </Typography>
                  </Box>

                  <Box className="toggle-btn-wrapper">
                    {toggleValue !== 'bar' && (
                      <SelectComponent
                        name="careerSorting"
                        isSearchable={false}
                        placeholder="Sort Careers"
                        selectOptions={sortingOptions}
                        className="black small"
                        value={sortCareerBy}
                        handleChange={handleSortingOptionChange}
                      />
                    )}
                    <ToggleButtonGroup
                      sx={{ border: 'none' }}
                      value={toggleValue}
                      exclusive
                      onChange={handleChangeView}
                    >
                      <ToggleButton key="right" size="small" value="bar">
                        <LeaderboardIcon />
                      </ToggleButton>
                      <ToggleButton key="left" size="small" value="list">
                        <FormatListBulletedIcon />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Box>
                {isXs && (
                  <Accordion sx={{ mx: 0 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{ px: 3 }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                        <Typography variant="h4">Filters</Typography>

                        <Typography
                          sx={{ color: isRegion ? 'black' : 'unset' }}
                          component="p"
                          textAlign="left"
                          fontSize="15px !important"
                          fontWeight="400"
                        >
                          Use the filters to change your salary requirements, optimal training time,
                          and whether you'd like to see upskilling or reskilling career suggestions.
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ px: 3 }}>
                      {isRegion && handleToggle && (
                        <Box
                          sx={{
                            mb: 2,
                            width: '100%',
                            border: `1px solid ${buttonColor}`,
                            borderRadius: 1,
                          }}
                        >
                          <Tabs
                            value={isReskill ? 1 : 0}
                            onChange={(e, newValue) => {
                              if ((newValue === 1 && !isReskill) || (newValue === 0 && isReskill)) {
                                handleToggle();
                              }
                            }}
                            variant="fullWidth"
                            sx={{
                              '& .MuiTab-root': {
                                color: buttonColor,
                                textTransform: 'none',
                                fontSize: '1rem',
                                backgroundColor: primaryColor,
                                '&:first-of-type': {
                                  borderRadius: '8px 0 0 8px',
                                },
                                '&:last-of-type': {
                                  borderRadius: '0 8px 8px 0',
                                },
                              },
                              '& .Mui-selected': {
                                color: 'black',
                                backgroundColor: buttonColor,
                                '&:first-of-type': {
                                  borderRadius: '8px 0 0 8px',
                                },
                                '&:last-of-type': {
                                  borderRadius: '0 8px 8px 0',
                                },
                              },
                              '& .MuiTabs-indicator': {
                                backgroundColor: 'unset',
                              },
                              '.css-j3fxsj-MuiButtonBase-root-MuiTab-root:not(:last-of-type)': {
                                marginRight: '0px',
                              },
                              '.css-kqhgxw-MuiTabs-scroller': {
                                backgroundColor: primaryColor,
                                borderRadius: '8px',
                                color: buttonColor,
                              },
                              '& .MuiTab-root:not(:last-of-type)': {
                                marginRight: { xs: 0, sm: 0 },
                              },
                              [thm.breakpoints.up('sm')]: {
                                '& .MuiTab-root:not(:last-of-type)': {
                                  marginRight: '0px !important',
                                },
                              },
                            }}
                          >
                            <Tab label="Upskill" />
                            <Tab label="Reskill" />
                          </Tabs>
                        </Box>
                      )}
                      <Box className="filter">
                        <Stack mt={1} gap={{ xs: 2, sm: 4 }} direction="column">
                          <Typography
                            variant="body"
                            sx={{
                              width: '100%',
                              textAlign: 'left',
                              marginTop: '5px',
                              fontSize: '0.9rem !important',
                            }}
                          >
                            Salary Preference
                          </Typography>
                          <Box mx={2}>
                            <BarSlider
                              min={minMaxSalary[0]}
                              max={minMaxSalary[1]}
                              value={salaryRange}
                              onChange={handleSalaryChange}
                              sliderColor={primaryColor} // dynamic color for track/valueLabel
                              thumbColor={buttonColor} // dynamic color for thumb
                              // valueLabelDisplay="auto"
                              // defaultValue={20}
                            />
                            <Typography
                              sx={{
                                fontSize: '0.9rem !important',
                                marginTop: '-12px',
                                textAlign: 'center',
                              }}
                            >
                              {`${currencyFormat(salaryRange[0])}\u00A0 to \u00A0 ${currencyFormat(
                                salaryRange[1]
                              )}`}
                            </Typography>
                          </Box>
                        </Stack>

                        <Stack gap={{ xs: 2, sm: 4 }} direction="column">
                          <Typography
                            variant="body"
                            sx={{
                              width: '100%',
                              textAlign: 'left',
                              marginTop: '5px',
                              fontSize: '0.9rem !important',
                            }}
                          >
                            Transfer Window
                          </Typography>
                          <Box mx={2}>
                            <BarSlider
                              min={minMaxTransfer[0]}
                              max={minMaxTransfer[1]}
                              value={transferWindowRange}
                              onChange={handleTransferChange}
                              sliderColor={primaryColor} // dynamic color for track/valueLabel
                              thumbColor={buttonColor} // dynamic color for thumb
                              // valueLabelDisplay="auto"
                              // defaultValue={20}
                            />
                            <Typography
                              sx={{
                                fontSize: '0.9rem !important',
                                marginTop: '-12px',
                                textAlign: 'center',
                              }}
                            >
                              {`${transferWindowRange[0]}\u00A0 to \u00A0 ${transferWindowRange[1]} \u00A0 Years`}
                            </Typography>
                          </Box>
                        </Stack>
                      </Box>
                      {/* Mobile Compare Career Section */}
                      <Box className="selected-career-wrapper" sx={{ mt: 3 }}>
                        <Typography sx={{ color: 'black', mb: 2 }} variant="h6">
                          Selected Careers ({careerCount} /{' '}
                          {preSelectedCareers?.CareerGoal && preSelectedCareers?.CurrentRole
                            ? 7
                            : 6}
                          )
                        </Typography>
                        <Stack alignItems="flex-start" sx={{ mb: 2 }}>
                          {/* Display Current Role careers */}
                          {(() => {
                            // First try to find current role in state
                            const currentRoleFromState = careerHistoryId
                              ?.map((careerId) => {
                                const career = careersUpskillTime?.sectorOrSubsector
                                  ?.flatMap((sector) => sector?.careers || [])
                                  ?.find((c) => c?.id === careerId);
                                return career ? (
                                  <Stack
                                    key={careerId}
                                    direction="row"
                                    pb="4px"
                                    gap={{ xs: 0, sm: 1 }}
                                    alignItems="center"
                                  >
                                    <Box sx={{ mr: 0.7 }}>
                                      <BadgeIcon sx={{ fontSize: '16px' }} />
                                    </Box>
                                    <Typography
                                      sx={{
                                        color: 'black',
                                        textAlign: 'left',
                                        fontSize: '0.85rem',
                                      }}
                                      lineHeight={1.5}
                                      variant="body"
                                    >
                                      <em>{career.name}</em>
                                      {/* <span
                                        style={{
                                          color: buttonColor,
                                          fontWeight: 600,
                                          marginLeft: '6px',
                                        }}
                                      >
                                        (Current Role)
                                      </span> */}
                                    </Typography>
                                  </Stack>
                                ) : null;
                              })
                              .filter(Boolean);

                            // If no current role found in state, use direct prop data
                            if (currentRoleFromState?.length === 0 && currentRoleDisplay) {
                              return (
                                <Stack
                                  key="current-role-direct"
                                  direction="row"
                                  pb="4px"
                                  gap={{ xs: 0, sm: 1 }}
                                  alignItems="center"
                                >
                                  <Box sx={{ mr: 0.7 }}>
                                    <BadgeIcon sx={{ fontSize: '16px' }} />
                                  </Box>
                                  <Typography
                                    sx={{ color: 'black', textAlign: 'left', fontSize: '0.85rem' }}
                                    lineHeight={1.5}
                                    variant="body"
                                  >
                                    <em>{currentRoleDisplay.name}</em>
                                    {/* <span
                                      style={{
                                        color: currentRoleDisplay.color,
                                        fontWeight: 600,
                                        marginLeft: '6px',
                                      }}
                                    >
                                      (Current Role)
                                    </span> */}
                                  </Typography>
                                </Stack>
                              );
                            }

                            return currentRoleFromState;
                          })()}
                          {/* Display Career Goal */}
                          {careerGoalId && (
                            <Stack
                              direction="row"
                              pb="4px"
                              gap={{ xs: 0, sm: 1 }}
                              alignItems="center"
                            >
                              <Box sx={{ mr: 0.7 }}>
                                <SvgIcon
                                  component={flagIcon}
                                  inheritViewBox
                                  sx={{ fontSize: '16px' }}
                                />
                              </Box>
                              <Typography
                                sx={{ color: 'black', textAlign: 'left', fontSize: '0.85rem' }}
                                lineHeight={1.5}
                                variant="body"
                              >
                                <em>
                                  {careersUpskillTime?.sectorOrSubsector
                                    ?.flatMap((sector) => sector?.careers || [])
                                    ?.find((c) => c?.id === careerGoalId)?.name ||
                                    'Career Goal Selected'}
                                </em>
                              </Typography>
                            </Stack>
                          )}
                          {/* Display compared careers */}
                          {compareCareersState.map((career) => (
                            <Stack
                              key={career}
                              direction="row-reverse"
                              pb="4px"
                              gap={{ xs: 0, sm: 1 }}
                              alignItems="center"
                            >
                              <Typography
                                sx={{ color: 'black', fontSize: '0.85rem' }}
                                lineHeight={1.5}
                                textAlign="left"
                                variant="body"
                              >
                                {
                                  careersUpskillTime?.sectorOrSubsector
                                    ?.find((sector) =>
                                      sector?.careers?.some((current) => current?.id === career)
                                    )
                                    ?.careers.find((curr) => curr?.id === career)?.name
                                }
                              </Typography>
                              <IconButton
                                color="inherit"
                                onClick={() => addToCompare(career)}
                                sx={{ padding: '4px', color: 'black' }}
                              >
                                <RemoveCircleOutlineOutlined
                                  sx={{ color: 'black', fontSize: '18px' }}
                                />
                              </IconButton>
                            </Stack>
                          ))}
                        </Stack>

                        <Stack direction="column" gap={1.5}>
                          <Button
                            fullWidth
                            sx={{
                              textTransform: 'none',
                              borderRadius: 'unset',
                              backgroundColor: (theme) => {
                                if (isRegion && buttonColor) {
                                  return buttonColor;
                                }
                                return `${theme.palette.secondary.main} !important`;
                              },
                              fontSize: '0.9rem',
                              py: 1.5,
                            }}
                            variant="contained"
                            endIcon={
                              <CompareIcon
                                sx={{
                                  color:
                                    isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                                }}
                              />
                            }
                            onClick={showCompareCareersPopup}
                          >
                            <Typography
                              sx={{
                                color:
                                  isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                              }}
                              variant="button1"
                            >
                              Career Information
                            </Typography>
                          </Button>
                          {/* <Button
                            fullWidth
                            sx={{
                              textTransform: 'none',
                              borderRadius: 'unset',
                              backgroundColor: (theme) => {
                                if (isRegion && buttonColor) {
                                  return buttonColor;
                                }
                                return `${theme.palette.secondary.main} !important`;
                              },
                              fontSize: '0.9rem',
                              py: 1.5,
                            }}
                            variant="contained"
                            endIcon={
                              <FileDownloadOutlinedIcon
                                sx={{
                                  color:
                                    isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                                }}
                              />
                            }
                            onClick={() => getSkillReport('careers-page')}
                          >
                            <Typography
                              sx={{
                                color:
                                  isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                              }}
                              variant="button1"
                            >
                              Get Skills Report
                            </Typography>
                          </Button> */}
                        </Stack>
                      </Box>

                      <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'flex-end', pt: 3 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: isRegion ? 'black' : 'unset',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <strong style={{ fontSize: '14px' }}>Key:</strong>
                          <span
                            style={{
                              backgroundColor: primaryColor,
                              borderRadius: '50%',
                              display: 'inline',
                              marginInline: '10px',
                              paddingTop: '5px',
                            }}
                          >
                            <StarIcon sx={{ mx: 1, color: 'white', fontSize: '24px' }} />
                          </span>
                          Identifies priority sectors
                        </Typography>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}

                {toggleValue === 'bar' ? (
                  <BarsComponent
                    Careers={Careers}
                    data={filteredSectors}
                    // data={careersUpskillTime?.sectorOrSubsector}
                    addToCompare={addToCompare}
                    compareCareersState={compareCareersState}
                    showCareerDetailsPopup={showCareerDetailsPopup}
                    widthClass={widthClass}
                  />
                ) : (
                  <ListComponent
                    sortCareerBy={sortCareerBy}
                    data={Careers}
                    addToCompare={addToCompare}
                    compareCareersState={compareCareersState}
                    showCareerDetailsPopup={showCareerDetailsPopup}
                  />
                )}
              </Box>
              {!isXs && (
                <Box
                  className="filter-wrapper"
                  sx={{
                    background: (theme) => (isRegion ? 'white' : `${theme.palette.primary.main}`),
                    borderRadius: {
                      xs: '0 0 12px 12px',
                      '@media (min-width: 1024px)': {
                        borderRadius: '0 0 12px 0',
                      },
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'auto',
                    position: 'sticky',
                    top: 0,
                  }}
                >
                  <Stack sx={{ height: '100%' }} direction="column" justifyContent="space-between">
                    <Box display="flex" flexDirection="column">
                      <Box className="filter">
                        {isRegion && handleToggle && (
                          <Box
                            sx={{
                              mb: 3,
                              width: '100%',
                              border: `1px solid ${buttonColor}`,
                              borderRadius: 1,
                            }}
                          >
                            <Tabs
                              value={isReskill ? 1 : 0}
                              onChange={(e, newValue) => {
                                if (
                                  (newValue === 1 && !isReskill) ||
                                  (newValue === 0 && isReskill)
                                ) {
                                  handleToggle();
                                }
                              }}
                              variant="fullWidth"
                              sx={{
                                '& .MuiTab-root': {
                                  color: buttonColor,
                                  textTransform: 'none',
                                  fontSize: '1.2rem',
                                  backgroundColor: primaryColor,
                                  '&:not(.Mui-selected)': {
                                    color: buttonColor,
                                    backgroundColor: primaryColor,
                                  },
                                  '&:first-of-type': {
                                    borderRadius: '8px 0 0 8px',
                                  },
                                  '&:last-of-type': {
                                    borderRadius: '0 8px 8px 0',
                                  },
                                },
                                '& .Mui-selected': {
                                  color: 'black',
                                  backgroundColor: buttonColor,
                                  '&:first-of-type': {
                                    borderRadius: '8px 0 0 8px',
                                  },
                                  '&:last-of-type': {
                                    borderRadius: '0 8px 8px 0',
                                  },
                                },
                                '& .MuiTabs-indicator': {
                                  backgroundColor: 'unset',
                                },
                                '.css-j3fxsj-MuiButtonBase-root-MuiTab-root:not(:last-of-type)': {
                                  marginRight: '0px',
                                },
                                '.css-kqhgxw-MuiTabs-scroller': {
                                  backgroundColor: primaryColor,
                                  borderRadius: '8px',
                                },
                                '& .MuiTab-root:not(:last-of-type)': {
                                  marginRight: { xs: 0, sm: 0 },
                                },
                                [thm.breakpoints.up('sm')]: {
                                  '& .MuiTab-root:not(:last-of-type)': {
                                    marginRight: '0px !important',
                                  },
                                },
                              }}
                            >
                              <Tab label="Upskill" />
                              <Tab label="Reskill" />
                            </Tabs>
                          </Box>
                        )}
                        <Typography
                          sx={{ color: isRegion ? 'black' : 'unset', mt: 3 }}
                          variant="h5"
                        >
                          Filters:
                        </Typography>
                        <Typography
                          sx={{ color: isRegion ? 'black' : 'unset' }}
                          component="p"
                          textAlign="left"
                          fontSize="15px !important"
                          fontWeight="400"
                        >
                          Use the filters to change your salary requirements, optimal training time,
                          and whether you'd like to see upskilling or reskilling career suggestions.
                        </Typography>

                        <Box display="flex" flexDirection="column" width="100%" gap={3}>
                          <Stack
                            mt={1}
                            gap={{ xs: 0, sm: 1 }}
                            flexGrow={1}
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Typography
                              variant="body"
                              sx={{
                                width: { xs: '100%' },
                                textAlign: 'left',
                                marginTop: '5px',
                                color: isRegion ? 'black' : 'unset',
                                fontSize: '18px !important',
                                fontWeight: '700',
                                ml: 3,
                              }}
                            >
                              Salary Preference
                            </Typography>
                            <Box
                              sx={{
                                maxWidth: { xs: 300, sm: 350 },
                                width: { xs: '100%' },
                              }}
                            >
                              <BarSlider
                                min={minMaxSalary[0]}
                                max={minMaxSalary[1]}
                                value={salaryRange}
                                onChange={handleSalaryChange}
                                sliderColor={primaryColor} // dynamic color for track/valueLabel
                                thumbColor={buttonColor} // dynamic color for thumb
                                // valueLabelDisplay="auto"
                                // defaultValue={20}
                              />
                              <Typography
                                sx={{
                                  color: isRegion ? 'black' : 'unset',
                                  fontSize: '0.9rem !important',
                                  marginTop: '-12px',
                                  textAlign: 'center',
                                  fontWeight: '700',
                                }}
                              >
                                {`${currencyFormat(
                                  salaryRange[0]
                                )}\u00A0 to \u00A0 ${currencyFormat(salaryRange[1])}`}
                              </Typography>
                            </Box>
                          </Stack>

                          <Stack
                            gap={{ xs: 0, sm: 1 }}
                            flexGrow={1}
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Typography
                              variant="body"
                              sx={{
                                color: isRegion ? 'black' : 'unset',
                                marginTop: '13px',
                                width: { xs: '100%' },
                                textAlign: 'left',
                                fontSize: '18px !important',
                                fontWeight: '700',
                                ml: 3,
                              }}
                            >
                              Transfer Window
                            </Typography>
                            <Box
                              sx={{
                                maxWidth: { xs: 300, sm: 350 },
                                width: { xs: '100%' },
                              }}
                            >
                              <BarSlider
                                min={minMaxTransfer[0]}
                                max={minMaxTransfer[1]}
                                value={transferWindowRange}
                                onChange={handleTransferChange}
                                sliderColor={primaryColor} // dynamic color for track/valueLabel
                                thumbColor={buttonColor} // dynamic color for thumb
                                // valueLabelDisplay="auto"
                                // defaultValue={20}
                              />
                              <Typography
                                sx={{
                                  color: isRegion ? 'black' : 'unset',
                                  fontSize: '0.9rem !important',
                                  marginTop: '-12px',
                                  textAlign: 'center',
                                  fontWeight: '700',
                                }}
                              >
                                {`${transferWindowRange[0]}\u00A0 to \u00A0 ${transferWindowRange[1]} \u00A0 Years`}
                              </Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Box>

                      <Box className="selected-career-wrapper">
                        <Stack mt={2} gap={1} direction="column" alignItems="flex-start">
                          <Typography sx={{ color: isRegion ? 'black' : 'unset' }} variant="h5">
                            Selected Careers ({careerCount} /{' '}
                            {preSelectedCareers?.CareerGoal && preSelectedCareers?.CurrentRole
                              ? 7
                              : 6}
                            )
                          </Typography>
                          <Stack alignItems="flex-start">
                            {/* Display Current Role careers */}
                            {(() => {
                              const currentRoleFromState = careerHistoryId
                                ?.map((careerId) => {
                                  const career = careersUpskillTime?.sectorOrSubsector
                                    ?.flatMap((sector) => sector?.careers || [])
                                    ?.find((c) => c?.id === careerId);
                                  return career ? (
                                    <Stack
                                      key={careerId}
                                      direction="row"
                                      pb="4px"
                                      gap={{ xs: 0, sm: 1 }}
                                      alignItems="center"
                                    >
                                      {/* <Box sx={{ mr: 0.7, padding: { sm: '0px !important' } }}> */}
                                      {/* </Box> */}
                                      <Typography
                                        sx={{
                                          color: 'black',
                                          textAlign: 'left',
                                          display: 'flex',
                                          alignItems: 'center',
                                          // flexWrap: 'wrap',
                                          gap: 2.5,
                                        }}
                                        lineHeight={1.7}
                                        pb="4px"
                                        variant="body"
                                      >
                                        <BadgeIcon sx={{ ml: 1 }} />
                                        <em style={{ fontStyle: 'normal' }}>{career.name}</em>
                                      </Typography>
                                    </Stack>
                                  ) : null;
                                })
                                .filter(Boolean);

                              if (currentRoleFromState?.length === 0 && currentRoleDisplay) {
                                return (
                                  <Stack
                                    key="current-role-direct"
                                    direction="row"
                                    pb="4px"
                                    gap={{ xs: 0, sm: 1 }}
                                    alignItems="center"
                                  >
                                    {/* <Box sx={{ mr: 0.7, padding: { sm: '0px !important' } }}></Box> */}
                                    <Typography
                                      sx={{
                                        color: isRegion ? 'black' : 'unset',
                                        textAlign: 'left',
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        gap: 2.5,
                                      }}
                                      lineHeight={1.7}
                                      pb="4px"
                                      variant="body"
                                    >
                                      <BadgeIcon sx={{ ml: 1 }} />
                                      <em style={{ fontStyle: 'normal' }}>
                                        {currentRoleDisplay.name}
                                      </em>
                                    </Typography>
                                  </Stack>
                                );
                              }

                              return currentRoleFromState;
                            })()}
                            {/* Display Career Goal */}
                            {careerGoalId && (
                              <Stack
                                direction="row"
                                pb="4px"
                                gap={{ xs: 0, sm: 1 }}
                                alignItems="center"
                              >
                                <Box sx={{ mr: 0.7 }}>
                                  <SvgIcon component={flagIcon} inheritViewBox />
                                </Box>
                                <Typography
                                  sx={{ color: isRegion ? 'black' : 'unset', textAlign: 'left' }}
                                  lineHeight={1.7}
                                  pb="4px"
                                  variant="body"
                                >
                                  <em>
                                    {careersUpskillTime?.sectorOrSubsector
                                      ?.flatMap((sector) => sector?.careers || [])
                                      ?.find((c) => c?.id === careerGoalId)?.name ||
                                      'Career Goal Selected'}
                                  </em>
                                </Typography>
                              </Stack>
                            )}
                            {/* <Typography lineHeight={1.7} pb='4px' variant='body'>
                                                        <em>{careersUpskillTime?.sectorOrSubsector?.find(sector =>
                                                            sector?.careers?.some(current => current?.careerType === "CAREER_GOAL"))?.careers.find(curr => curr?.careerType === "CAREER_GOAL")?.name}
                                                        </em>
                                                    </Typography> */}
                            {compareCareersState.map((career) => (
                              <Stack
                                direction="row-reverse"
                                pb="4px"
                                gap={{ xs: 0, sm: 1 }}
                                alignItems="center"
                              >
                                <Typography
                                  sx={{ color: isRegion ? 'black' : 'unset' }}
                                  lineHeight={1.7}
                                  textAlign="left"
                                  variant="body"
                                >
                                  {/* {Careers.find(current => current?.id === career)?.name} */}
                                  {
                                    careersUpskillTime?.sectorOrSubsector
                                      ?.find((sector) =>
                                        sector?.careers?.some((current) => current?.id === career)
                                      )
                                      ?.careers.find((curr) => curr?.id === career)?.name
                                  }
                                </Typography>
                                <IconButton
                                  color="inherit"
                                  onClick={() => addToCompare(career)}
                                  sx={{ padding: '6px 10px', color: isRegion ? 'black' : 'unset' }}
                                >
                                  <RemoveCircleOutlineOutlined
                                    sx={{ color: isRegion ? 'black' : 'unset' }}
                                    fontSize="medium"
                                  />
                                </IconButton>
                              </Stack>
                            ))}
                          </Stack>
                        </Stack>

                        <Stack
                          direction="row"
                          justifyContent="center"
                          flexWrap="wrap"
                          gap={{ xs: 1.2, sm: 2 }}
                          mt={2}
                          pb={{ xs: 0, md: 2 }}
                        >
                          {/* <Button variant='contained'  onClick={showCompareCareersPopup}>
                                <Typography variant='body1'  >Career Information</Typography><CompareIcon /> <span className='badge'>{compareCareersState?.length}</span>
                            </Button> */}
                          <Button
                            sx={{
                              textTransform: 'none',
                              width: { xs: '100%', sm: 'unset' },
                              borderRadius: 'unset',
                              backgroundColor: (theme) => {
                                if (isRegion && buttonColor) {
                                  return buttonColor;
                                }
                                return `${theme.palette.secondary.main} !important`;
                              },
                              ...(isRegion &&
                                buttonColor && {
                                  '&:hover': {
                                    backgroundColor: buttonColor,
                                    opacity: 0.9,
                                  },
                                }),
                            }}
                            variant="contained"
                            endIcon={
                              <CompareIcon
                                sx={{
                                  color:
                                    isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                                }}
                              />
                            }
                            onClick={showCompareCareersPopup}
                          >
                            <Typography
                              sx={{
                                color:
                                  isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                              }}
                              variant="button1"
                            >
                              Career Information
                            </Typography>
                          </Button>
                          {/* <Button
                            sx={{
                              textTransform: 'none',
                              width: { xs: '100%', sm: 'unset' },
                              ...(isRegion &&
                                buttonColor && {
                                  '&:hover': {
                                    backgroundColor: buttonColor,
                                    opacity: 0.9,
                                  },
                                }),
                              borderRadius: 'unset',
                              backgroundColor: (theme) => {
                                if (isRegion && buttonColor) {
                                  return buttonColor;
                                }
                                return `${theme.palette.secondary.main} !important`;
                              },
                            }}
                            variant="contained"
                            endIcon={
                              <FileDownloadOutlinedIcon
                                sx={{
                                  color:
                                    isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                                }}
                              />
                            }
                            onClick={() => getSkillReport('careers-page')}
                          >
                            <Typography
                              sx={{
                                color:
                                  isRegion && buttonFontColor ? buttonFontColor : 'primary.white',
                              }}
                              variant="button1"
                            >
                              Get Skills Report
                            </Typography>
                          </Button> */}
                        </Stack>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        position: 'sticky',
                        bottom: 0,
                        backgroundColor: isRegion ? 'white' : '#fff',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        py: 2,
                        px: 2,
                        zIndex: 10,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: isRegion ? 'black' : 'unset',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '16px !important',
                        }}
                      >
                        <strong style={{ fontSize: '20px' }}>Key:</strong>
                        <span
                          style={{
                            backgroundColor: primaryColor,
                            borderRadius: '50%',
                            display: 'inline',
                            marginInline: '10px',
                            paddingTop: '5px',
                            paddingInline: '5px',
                          }}
                        >
                          <StarIcon sx={{ color: 'white', fontSize: '24px' }} />
                        </span>
                        Identifies priority sectors
                      </Typography>
                    </Box>
                    {/* <Box
                                        // sx={{ mb: 4 }}
                                        className='ai-video-wrapper'
                                    >
                                        <Box sx={showLabel ? videoClassOpen : videoClassClose} className='video-position'>
                                            <AiVideo
                                                closeLabel={closeLabel}
                                                url={reskillBar ? `${Ai_Video_Url}bar-chart-reskill.mp4` : `${Ai_Video_Url}bar-chart-upskill.mp4`}
                                                position='default'
                                            />
                                        </Box>
                                    </Box> */}
                  </Stack>
                </Box>
              )}
            </>
          )}
        </>
      </Box>
    </>
  );
};

export default GraphsData;

GraphsData.propTypes = {
  showCompareCareersPopup: PropTypes.bool,
  reskillBar: PropTypes.bool,
  isLoading: PropTypes.bool,
  compareCareersState: PropTypes.array,
  careerHistoryId: PropTypes.array,
  careerGoalId: PropTypes.array,
  careersUpskillTime: PropTypes.object,
  regionData: PropTypes.object,
  addToCompare: PropTypes.func,
  showCareerDetailsPopup: PropTypes.func,
  getSkillReport: PropTypes.func,
  status: PropTypes.func,
  scrollRef: PropTypes.func,
  isRegion: PropTypes.bool,
  collegeId: PropTypes.string,
  IP: PropTypes.string,
  handleToggle: PropTypes.func,
  isReskill: PropTypes.bool,
  currentRoleData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};
